import 'vue-slider-component/theme/default.css'
import TransactionsDetailedHeader from '../TransactionsDetailedHeader/index'
import { mapGetters } from 'vuex'
export default {
  name: 'DMIForm',
  components: { TransactionsDetailedHeader },
  computed: {
    ...mapGetters(['user'])
  },
  mounted () {
    this.$store.dispatch('userDetails')
  }
}



// WEBPACK FOOTER //
// ./src/components/DMIForm/component.js